// 独立vuex模块 用户模块
import { getWeekday } from "@/utils";

const state = {
   year:'',
  month:'',
  day:'',
  week:'',
  date:''
}
// 同步操作
const mutations = {
  SET_Time(state, item) {
    state.year = Number(item.slice(0,4))
    state.month = Number(item.slice(5,7))
    state.day = Number(item.slice(8))
    state.week = getWeekday(item)
    state.date = item
  }
}
// 异步操作
const actions = {

}

export default {
  namespaced: true, // 开启命名空间模块
  state,
  mutations,
  actions,
}
